import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_BUSINESS_USERS: (query) => ({ query }),
    API: {
      GET_BUSINESS_USERS: apiResourceActionCreator('businessUsers')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getBusinessUsers?${queryString.stringify(query)}`, authToken, action.admin.api.getBusinessUsers)

function* getBusinessUsers(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'getBusinessUsers',
  action: action,
  sagas: getBusinessUsers,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingBusinessUser: true
    }),
    success: (state, action) => {
      const newUsers = action.payload.businessUsers.result;
      const updatedBusinessUserData = (!state.businessUserData || action.payload.businessUsers.skip === 0) ?
        action.payload.businessUsers : {
          ...state.businessUserData,
          result: state.businessUserData.result
            .filter((profile) => !newUsers.map((newUser) => newUser.user.id).includes(profile.user.id))
            .concat(newUsers)
        }
      return ({
        ...state,
        isFetchingBusinessUser: false,
        businessUserData: updatedBusinessUserData
      })
    },
    failed: (state, action) => ({
      ...state,
      isFetchingBusinessUser: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getBusinessUsers.js